export default {
  account: () => import("D:/tjtw/edu/education-web/layouts/account.vue").then(m => m.default || m),
  activity: () => import("D:/tjtw/edu/education-web/layouts/activity.vue").then(m => m.default || m),
  buy: () => import("D:/tjtw/edu/education-web/layouts/buy.vue").then(m => m.default || m),
  course: () => import("D:/tjtw/edu/education-web/layouts/course.vue").then(m => m.default || m),
  default: () => import("D:/tjtw/edu/education-web/layouts/default.vue").then(m => m.default || m)
}